export const menuItems = [
  {
    title: 'My Properties',
    icon: 'home',
    route: 'properties',
  },
  {
    title: 'Settings',
    icon: 'settings',
    route: 'profile',
  },
  {
    title: 'Support',
    icon: 'help',
    route: 'support',
  },
];
